<script setup lang="ts">
import { addSearchTermIntoCookie } from "~/utils/cookies/searchCookies"
import { ButtonProps } from "~/components/Utils/Button.props"
import type { PopularSearchProps } from "./PopularSearch.props"
import { checkEnvSite } from "~~/server/utils/getAlgoliaConfig"

defineProps<PopularSearchProps>()

const { switchState } = useUIState("focus-search")
const showSearchPopup = () => switchState(true)

const { data: topQueries } = useLazyFetch(`/api/algolia/getQuerySuggestions`, {
  server: false
})

const lastQueries = useStatefulCookie("lastQueries", {
  maxAge: 2592000,
  default: () => []
})

const topQueriesMapped = computed<Array<ButtonProps>>(() => {
  return topQueries?.value?.hits.map((hit) => ({
    text: hit.query
  }))
})

// See AlgoliaSearchbar component
const algoliaSearchbarQueryState = useState("searchbar-query-state")
const applyQuery = (text: string) => {
  useScrollTop()
  showSearchPopup()

  algoliaSearchbarQueryState.value = text
  lastQueries.value = addSearchTermIntoCookie(lastQueries.value, text)
}
</script>

<template>
  <div class="suggestions-related_search pb-8 pt-6">
    <p class="pig-bold pb-4">{{ title }}</p>

    <div class="flex flex-wrap gap-2 md:gap-6">
      <UtilsButton
        class="transform-gpu font-normal drop-shadow-01"
        v-for="tag in topQueriesMapped"
        :key="tag.text"
        theme="contained-white"
        v-bind="tag"
        @click="applyQuery(tag.text!)"
      />
    </div>
  </div>
</template>
